<template>
  <div>
    <div class="d-flex flex-row align-center justify-space-between mb-3">
      <div class="text-body-2">{{ properties.length }} propiedad(es) asignada(s)</div>
      <v-btn
        small
        depressed
        color="accent"
        class="rounded-lg"
        @click="
          $router.push({
            name: 'CreateProperty',
            query: { ownerId: ownerId }
          })
        "
      >
        Crear propiedad
      </v-btn>
    </div>

    <List
      ref="list"
      @reload="fetchProperties('no-cache')"
      :properties="properties"
    />
  </div>
</template>

<script>
import { OwnerProperties } from "@/graphql/queries/property";
import List from "@/components/properties/List";

export default {
  name: "Properties",
  data() {
    return {
      properties: []
    };
  },

  components: {
    List
  },

  created() {
    this.fetchProperties("no-cache");
  },

  props: {
    ownerId: {
      type: Number | String,
      default: null
    }
  },

  methods: {
    fetchProperties() {
      this.$apollo
        .query({
          query: OwnerProperties,
          variables: {
            ownerId: this.ownerId
          },
          fetchPolicy: "no-cache"
        })
        .then(res => {
          this.properties = res.data.ownerProperties.properties;
        });
    }
  }
};
</script>
